import { apiClient } from "../config";

async function getLimitedNotifications() {
  const res = await apiClient.get(`/admin/notifications/limited-notifications`);
  return res.data;
}

export default getLimitedNotifications;
